<div>
  <div><strong>{{'External Accounts Holdings '+rowCount}}</strong></div>
  <div style="margin-top:20px"><strong>Taxability</strong>
  <irb-dropdown-filter  style="margin-left:15px"  #irbTaxabilityDropdown (search)="getTaxabilityItems()" size="10" (selection) ="onTaxabilityChange($event)" [(value)]="selectedTaxability"></irb-dropdown-filter>
</div>
<div style="margin-top:10px">
  Symbol
  <irb-dropdown-search #externalSecurityDropdown (search)="populateSecuritiesDropdown($event)"
    (selection)="onExtHoldingChange($event)" (clearSelection)="clearExternalSecurity()"
  ></irb-dropdown-search>
  Quantity
  <!--    <irb-number-input-validator-->
  <!--      width="50px"-->
  <!--      [min]="0"-->
  <!--      [maxDecimalPlaces]="3"-->
  <!--      (value)="quantity = $event"-->
  <!--      [reset]="change"-->
<!--    ></irb-number-input-validator>-->
<irb-number-text-box
  width="80px"
  [min]="0"
  [places]="3"
  [isCurrency]="false"
  [isPercentage]="false"
  invalidMessage="The value entered is not valid."
[(value)]="quantity"></irb-number-text-box>

<button class=" btn-medium-primary"(click)="addExternalHoldingsToGrid()" [disabled]="!isValidSelections()">Add</button>
@if (toolTipShow) {
  <div class="tooltip">
    <span id="tooltiptext" class="tooltiptext">
      {{tooltipMessage}}
    </span>
  </div>
}
</div>

<div>

  <irb-inventory-grid
    [style.width]="'50%'"
    [style.height]="'200px'"
    [style.margin-top]="'10px'"
    [gridHeight]="'200px'"
    [showSideBar]="false"
    [gridOptions]="gridOptions"
    [frameworkComponents]='frameworkComponents'
  (gridReady)="onGridReady($event)"></irb-inventory-grid>
</div>
</div>
